import React from "react";
import SEO from "../components/shared/SEO";
import { getText } from "../libs/resources";
import InPress from "../components/shared/Press";

const Press = () => {
  return (
    <>
    <SEO
      title={getText().InPress.SEO.title}
      description={getText().InPress.SEO.description}
    ></SEO>
    <div>
        <InPress />
    </div>
  </>
  );
};

export default Press;